import { CustomerInfoFormInput } from './customerInfoValidation'
import { Address } from '../../types/models'
import { stateProvinceMap } from '../../utils/constants'
import { GeocodeRequest } from '../../types/hereMaps'

export function buildGeocodeRequest({
  streetAddress1,
  streetAddress2,
  city,
  stateProvince,
  country,
  postalCode,
}: CustomerInfoFormInput) {
  const geocodeRequestAddress = [
    `${streetAddress1} ${streetAddress2}`,
    city,
    stateProvince.value,
    country.value,
    postalCode,
  ].join(', ')

  const geocodeRequest: GeocodeRequest = {
    q: geocodeRequestAddress,
  }
  return geocodeRequest
}

export function buildShippingAddress({
  streetAddress1,
  streetAddress2,
  postalCode,
  city,
  stateProvince,
  country,
}: CustomerInfoFormInput) {
  const stateProvinceOptions = stateProvinceMap[country.value]
  const shippingAddress: Address = {
    addressLine1: streetAddress1,
    addressLine2: streetAddress2,
    postalCode: postalCode,
    city: city,
    state: stateProvinceOptions.find(
      (option) => option.value === stateProvince.value,
    )?.label,
    country: country.value,
  }
  return shippingAddress
}
